var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImportIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_18_2485)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36,
    width: 32,
    height: 32,
    rx: 16,
    transform: "rotate(90 36 0)",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0089 24C14.4782 24.0017 13.9687 23.7795 13.592 23.3823C13.2153 22.985 13.0024 22.4452 13 21.8813V9.11867C13 7.94989 13.8999 7 15.0089 7H22.9911L27 11.2437V21.8813C27 23.0501 26.1001 24 24.9911 24H15.0089ZM19.8 17.3413C19.8233 17.3743 19.8535 17.401 19.8881 17.4195C19.9229 17.4379 19.9611 17.4476 20 17.4476C20.0388 17.4476 20.077 17.4379 20.1118 17.4195C20.1464 17.401 20.1767 17.3743 20.1999 17.3413L22.6999 13.8C22.7278 13.7606 22.7448 13.7137 22.749 13.6645C22.7532 13.6155 22.7443 13.566 22.7235 13.5219C22.7028 13.4777 22.6709 13.4407 22.6314 13.4147C22.5919 13.3888 22.5463 13.3751 22.5 13.3751H21.25C21.1837 13.3751 21.1201 13.347 21.0731 13.2973C21.0263 13.2475 21 13.1799 21 13.1094V11.5157C21 11.4453 20.9736 11.3777 20.9268 11.3278C20.8799 11.278 20.8162 11.2501 20.7499 11.2501H19.25C19.1837 11.2501 19.12 11.278 19.0732 11.3278C19.0263 11.3777 18.9999 11.4453 18.9999 11.5157V13.1094C18.9999 13.1799 18.9737 13.2475 18.9268 13.2973C18.8798 13.347 18.8162 13.3751 18.75 13.3751H17.5C17.4536 13.3751 17.408 13.3888 17.3685 13.4147C17.3291 13.4407 17.2971 13.4777 17.2764 13.5219C17.2556 13.566 17.2468 13.6155 17.2509 13.6645C17.2551 13.7137 17.2721 13.7606 17.3 13.8L19.8 17.3413ZM17.5 18.6875C17.3673 18.6875 17.2401 18.7434 17.1464 18.8431C17.0526 18.9427 16.9999 19.0778 16.9999 19.2188C16.9999 19.3596 17.0526 19.4947 17.1464 19.5944C17.2401 19.694 17.3673 19.7499 17.5 19.7499H22.5C22.6326 19.7499 22.7598 19.694 22.8535 19.5944C22.9473 19.4947 23 19.3596 23 19.2188C23 19.0778 22.9473 18.9427 22.8535 18.8431C22.7598 18.7435 22.6326 18.6875 22.5 18.6875H17.5Z",
    fill: "#C7C7C7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_18_2485",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_18_2485"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_18_2485",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportIcon);
export default __webpack_public_path__ + "static/media/import-icon.9b1f33180890e2c3afe844222a746bd5.svg";
export { ForwardRef as ReactComponent };